import { createContextStore } from "@faire/web--source/ui/hooks/ContextStore";

import { LoggedOutContactUsEmailContext } from "../types";

const INITIAL_STATE: LoggedOutContactUsEmailContext = {
  businessName: "",
  contactEmail: "",
  details: "",
  emailErrorMessage: undefined,
  descriptionErrorMessage: undefined,
  businessNameErrorMessage: undefined,
  formErrorMessage: "",
};

const {
  useStore: useLoggedOutEmailContextStore,
  Provider: LoggedOutEmailContextProvider,
} = createContextStore<LoggedOutContactUsEmailContext>(INITIAL_STATE);

export { LoggedOutEmailContextProvider, useLoggedOutEmailContextStore };
